<template>
  <div>
    <Modal
      :class="{ 'create-order-modal': 'true', ['modal-step-' + step]: true }"
      v-model="show"
      :show-close="step == 1 || step == 100"
      action-text="חזור לעמוד הקודם"
      @action="orderModalBack"
      :closeOnOutsideClick="false"
    >
      <div v-if="step === 1 || step === 3" slot="icon" class="modal-icon">
        <svg
          width="39"
          height="39"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 3 39 39"
        >
          <g fill="none" fill-rule="evenodd">
            <path d="M0 .002h38.4v38.402H0z" />
            <path
              d="M32 22.86V9.6h-3.2v3.2H9.6l.002-3.2H6.4v13.26c-1.067.342-2.133.714-3.2 1.14v11.2h3.2V32H32v3.2h3.2V24a48.154 48.154 0 00-3.2-1.14zM28.8 16v5.96a41.32 41.32 0 00-8-1.12V16h8zM9.6 16h8v4.84a41.32 41.32 0 00-8 1.12V16zM6.4 28.8v-1.6H32v1.6H6.4z"
              fill="#FFF"
              fill-rule="nonzero"
            />
          </g>
        </svg>
      </div>
      <div
        v-else-if="step === 100"
        slot="icon"
        class="modal-icon"
        style="background: #f3f3f3; width: 66px; height: 66px"
      >
        <svg width="28" height="24" xmlns="http://www.w3.org/2000/svg">
          <g fill="#79BB3D" fill-rule="nonzero">
            <path
              d="M12.7 21.816a2.828 2.828 0 01-3.958.373 2.776 2.776 0 01-.376-3.928L22.693 1.057A2.827 2.827 0 0126.65.684a2.776 2.776 0 01.377 3.927L12.701 21.816z"
            />
            <path
              d="M12.2 18.843a2.776 2.776 0 01-.377 3.927 2.826 2.826 0 01-3.958-.373L.702 13.794a2.777 2.777 0 01.377-3.928 2.828 2.828 0 013.958.373l7.163 8.604z"
            />
          </g>
        </svg>
      </div>
      <div v-if="!data">
        <div class="lds-dual-ring"></div>
      </div>
      <div class="modal-split">
        <div class="modal-right">
          <div class="order-modal">
            <div class="order-modal-body">
              <CreateOrderStepOne
                v-if="step == 1"
                :packageData="packageData"
                :show="show"
                v-model="form"
                @done="onStepDone"
              />
              <CreateOrderStepTwo
                v-else-if="step == 2"
                :data="data"
                :packageData="packageData"
                v-model="form"
                @done="onStepDone"
              />
              <CreateOrderStepThree
                v-else-if="step == 3"
                :data="data"
                :packageData="packageData"
                v-model="form"
                @done="onStepDone"
              />
              <CreateOrderStepEnd v-else-if="step == 100" />
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <portal-target name="after-create-order-modal" />
  </div>
</template>

<script>
import moment from "moment";
import vClickOutside from "v-click-outside";
import Modal from "./Modal.vue";
import CreateOrderStepOne from "./CreateOrderStepOne.vue";
import CreateOrderStepTwo from "./CreateOrderStepTwo.vue";
import CreateOrderStepThree from "./CreateOrderStepThree.vue";
import CreateOrderStepEnd from "./CreateOrderStepEnd.vue";
import Vue from "vue";
import { $t } from "../../i18n";

import PortalVue from "portal-vue";
import { api } from "../../API";
Vue.use(PortalVue);

const DEFAULT_STATE = () => ({
  data: null,
  show: false,
  step: 1,
  errorMessage: null,
  wantedRooms: [],
  roomDropdown: false,
  submitting: false,
  form: {
    customer: {
      name: "",
      phone: "",
      email: ""
    },
    ageGroups: [
      { age: 18, name: $t("מבוגרים"), wantedCount: 0 },
      { age: 12, name: $t("ילדים מתחת לגיל 12"), wantedCount: 0 },
      { age: 2, name: $t("תינוקות 0-2"), wantedCount: 0 }
    ],
    rooms: []
  },
  moment: moment
});

export default {
  components: {
    Modal,
    CreateOrderStepOne,
    CreateOrderStepTwo,
    CreateOrderStepThree,
    CreateOrderStepEnd
  },

  props: {
    packageData: {
      type: Object
    }
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  mounted() {
    // console.log(this.packageData.siteName, "asl");
    // this.packageData = {
    //   siteName: "Site",
    //   date: "07/01/2021",
    //   hotelName: "Hotel",
    //   hotelPhoto:
    //     "https://www.skideal.co.il/app/uploads/2019/07/ezgif.com-crop.jpg",
    //   internalId: 9753,
    //   packageId: 7017,
    //   hotelCode: "FIC",
    //   date: "07/01/2021",
    //   internalId: 9753,
    //   packageId: 5885,
    //   hotelCode: "RRK",
    //   date: "17/12/2020",
    //   internalId: 8432,
    //   packageId: 7023,
    //   hotelCode: "PER"
    // };
  },

  data() {
    return DEFAULT_STATE();
  },

  methods: {
    orderModalBack() {
      this.onStepDone({ event: "back" });
    },
    canSubmit() {
      return (
        this.wantedRooms.filter(room => room.priceClass).length &&
        this.ageGroups.length
      );
    },

    airlineLogo(flight) {
      return (window.siteData.airlineLogos || {})[
        flight.airline_number.substring(0, 2).toUpperCase()
      ];
    },

    // When package wasn't found or stock isn't available.
    showContactModal() {
      this.show = false;
      const orderFormModal = $(".order-package-modal");

      orderFormModal
        .find("input[type=text][name=pkg_site_name]")
        .val(this.packageData.siteName);
      orderFormModal
        .find("input[type=text][name=pkg_date]")
        .val(this.packageData.date);
      orderFormModal
        .find("input[type=text][name=pkg_hotel]")
        .val(this.packageData.hotelName);

      orderFormModal.modal().show();
    },

    onStepDone(data) {
      if (data.setData) {
        this.data = data.setData;
      }

      switch (data.event) {
        case "next":
          this.step++;
          break;
        case "back":
          if (this.step <= 1) {
            this.show = false;
          }

          this.step--;
          break;
        case "error":
          // this.showContactModal();
          this.saveLead(data.orderStatus);
          this.step = 100;
          break;
      }
    },

    saveLead(orderStatus) {
      api.ordersSaveLead(this.packageData.internalId, {
        name: this.form.customer.name,
        phone: this.form.customer.phone,
        status: orderStatus,
        people: this.people
      });
    }
  },

  computed: {
    people() {
      let people = 0;

      for (let i in this.form.ageGroups) {
        const group = this.form.ageGroups[i];

        if (group.age >= 12) {
          people += group.wantedCount || 0;
        }
      }

      return people;
    }
  },

  watch: {
    packageData() {
      if (!this.packageData) {
        this.show = false;
        return;
      }

      let state = DEFAULT_STATE();

      for (let key in state) {
        this[key] = state[key];
      }

      this.show = true;
      this.data = {};
    },

    show() {
      if (this.show) {
        document.body.classList.add("create-order-modal-opened");
      } else {
        document.body.classList.add("create-order-modal-closed");
      }
    }
  }
};
</script>

<style lang="scss">
.lds-dual-ring {
  display: inline-block;
  margin: 15vh 10vw;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #000;
  border-color: #000 transparent #000 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  transform: scale(0.75);
  margin-top: 5px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

.create-order-modal {
  // position: relative;

  @media screen and (max-width: 991px) {
    align-items: flex-end !important;

    .modal-body-container {
      @media screen and (max-width: 991px) {
        height: 100%;
      }
    }

    .modal-body {
      margin: 0 !important;
      width: 100% !important;
      border-radius: 0 !important;
      height: 100%;
      background-color: #fff;
    }

    &.modal-step-2 {
      .modal-scroll {
        max-height: 100vh !important;
      }

      .modal-body {
        border-radius: 0 !important;
      }
    }
  }

  .modal-scroll {
    max-height: 80vh;

    @media screen and (max-width: 991px) {
      max-height: 100vh !important;
      height: 100%;
    }
  }

  .modal-content {
    .modal-split {
      width: 100vw;
      max-width: 979px;

      .modal-right {
        width: 100%;
        padding: 0 !important;
      }
    }
  }
  .create-order-modal-closed {
    display: block;
  }
}
</style>

<style lang="scss">
@media screen and (max-width: 991px) {
  .modal-icon {
    display: none !important;
  }
}

.order-modal {
  padding-bottom: 40px;

  .order-modal-body {
    .order-modal-split {
      display: flex;
      padding: 50px 0 0 0;

      > *:first-child,
      > *:last-child {
        padding: 0 30px;
        flex-basis: 50%;
      }

      > *:first-child {
        border-left: solid 1px rgba(151, 151, 151, 0.26);
      }

      @media screen and (max-width: 991px) {
        flex-wrap: wrap;

        > *:first-child,
        > *:last-child {
          flex-basis: 100%;
        }

        > *:first-child {
          border: none;
        }
      }

      h3 {
        font-size: 35px;
        font-weight: 900;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #333d57 !important;
      }

      .order-modal-rooms {
        display: flex;
        flex-direction: column;

        > ul {
          > li {
            margin-bottom: 15px;

            .room-head {
              display: flex;
              align-items: center;
              margin-bottom: 10px;

              h4 {
                font-size: 20px;
                font-weight: bold;
                margin: 0;
              }

              .delete-room-button {
                width: 22px;
                height: 22px;
                background-position: center;
                background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='4' viewBox='0 0 21 4'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0H31.36V31.36H0z' transform='translate(-4.728 -13.728)'/%3E%3Cpath stroke='%23000' stroke-width='2.509' d='M5.645 15.68L25.715 15.68' transform='translate(-4.728 -13.728)'/%3E%3C/g%3E%3C/svg%3E%0A");
                background-size: 10px;
                background-repeat: no-repeat;
                border: solid 0.6px #686868;
                border-radius: 50%;
                margin-left: 15px;
                cursor: pointer;
              }
            }

            > ul {
              display: flex;
              flex-wrap: wrap;

              > li {
                margin: 0 0 0 30px;
              }
            }
          }
        }

        .add-room-dropdown {
          position: relative;

          .add-room-button {
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: right;
            color: #393939;
            background-color: #dcdcdc;
            margin-bottom: 4px;
            border-radius: 3px;
          }

          ul {
            position: absolute;
            top: 100%;
            background-color: #fff;
            opacity: 0;
            pointer-events: none;
            background-color: #dcdcdc;
            padding: 5px;
            width: 50%;
            border-radius: 3px;
            margin: 0;
            padding: 0;
            transition: opacity 0.25s ease;

            &.visible {
              opacity: 1;
              pointer-events: auto;
            }

            > li {
              padding: 8px 18px;
              cursor: pointer;
              transition: background-color 0.2s ease;

              &:hover {
                background-color: rgba(255, 255, 255, 0.25);
              }

              &:not(:last-child) {
                border-bottom: solid 1px rgba(0, 0, 0, 0.15);
              }
            }
          }
        }
      }
    }
  }

  .order-modal-submit {
    display: flex;
    justify-content: center;
    width: 100%;

    button {
      border-radius: 8px;
      background-color: #1d1647;
      font-size: 24px;
      font-weight: bold;
      padding: 21px 30px;
      flex-grow: 1;
      flex-basis: 100%;
      max-width: 372px;
      margin: 44px 0 38px 0;
      height: 66px;
    }
  }
}
</style>
